import React from 'react';
import { Phone } from 'lucide-react';
import { site } from '../data/site';
export function CallBar() {
  return <a href={site.phoneHref} className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-center gap-3 border-t-4 border-[#0B1B3A] bg-[#FACC15] py-4 font-heading text-base font-black uppercase tracking-widest text-[#0B1B3A] sm:hidden" data-id="element-1" data-mp="121ty8qeo4sv2">
      <Phone className="h-5 w-5" aria-hidden="true" data-id="element-2" data-mp="edar4e7cum4k" />
      Call or text {site.phone}
    </a>;
}